import Vue from 'vue';
import router from '../../router'
import utils from "./utils";
import axios from 'axios';
import qs from 'qs';




axios.defaults.baseURL = '//appapi2.gamersky.com/v5/';
// axios.defaults.baseURL = '//router2.gamersky.com/@';

axios.defaults.withCredentials = true;

const ajax = {
    // v5ApiUrl: "/appapi2v5",
    // v5ApiUrl: "http://appapi2.gamersky.com/v5",
   
    post: function (url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.post(url, data)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    get: function (url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    put: function (url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.put(url, qs.stringify(data))
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    del: function (url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.delete(url, qs.stringify(data))
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    getQueryString: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },

    jsonp: function (url, data = {}) {
        if (!url)
          throw new Error('url is necessary')
        const callback = 'CALLBACK' + Math.random().toString().substr(9, 18)
        const JSONP = document.createElement('script')
        JSONP.setAttribute('type', 'text/javascript')
    
        const headEle = document.getElementsByTagName('head')[0]
        let ret = '';
        if (data) {
          if (typeof data === 'string')
            ret = '&' + data;
          else if (typeof data === 'object') {
            for (let key in data)
              ret += '&' + key + '=' + encodeURIComponent(data[key]);
          }
          ret += '&_=' + Date.now();
        }
        JSONP.src = `${url}?callback=${callback}${ret}`;
        return new Promise((resolve, reject) => {
          window[callback] = r => {
            resolve(r)
            headEle.removeChild(JSONP)
            delete window[callback]
          }
          headEle.appendChild(JSONP)
        })
      },
};

// 请求拦截器
// axios.interceptors.request.use(request => {
//     if (request.url.indexOf('sales/login') === -1 && request.url.indexOf('sales/user/sendSmsCode') === -1) {
//         let token = utils.storage.get("Authorization") ? "Bearer " + utils.storage.get("Authorization") : "";
//         request.headers["Authorization"] = token;
//     }

//     return request
// }, (error) => {
//     return Promise.reject(error);
// });
// 响应拦截器
// axios.interceptors.response.use(response => {
//     // token验证失败
//     if (response.data.code > 1000 && response.data.code < 2000) {
//         utils.storage.remove("Authorization");
//         router.push({ name: "login" });
//     }
//     return response;
// }, err => {
//     // console.log(err);
//     return Promise.reject(err)
// })

export default ajax;
